import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getNonTradingDays4Fund,
  saveNonTradingDays4FundBatch,
} from '../../api/nonTradingDays4Fund';
import type { NonTradingDay4Fund } from '../../types/NonTradingDay4Fund';
import { dateColumnProps } from '../../utils/dateColumn';
import { t } from '../../i18n/t';

const columnDefs: ColDef<NonTradingDay4Fund>[] = [
  {
    field: 'recId',
    headerName: t('nonTradingDays4Fund.columns.recId'),
    width: 110,
    editable: false,
    cellDataType: 'number',
  },
  {
    field: 'dDate',
    headerName: t('nonTradingDays4Fund.columns.dDate'),
    width: 160,
    editable: true,
    sort: 'desc',
    ...dateColumnProps<NonTradingDay4Fund>('dDate'),
  },
  {
    field: 'fundId',
    headerName: t('nonTradingDays4Fund.columns.fundId'),
    width: 120,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'comment',
    headerName: t('nonTradingDays4Fund.columns.comment'),
    flex: 1,
    minWidth: 240,
    editable: true,
  },
  {
    field: 'userId',
    headerName: t('nonTradingDays4Fund.columns.userId'),
    width: 120,
    editable: true,
    cellDataType: 'number',
  },
];

const newDefaults = (): Partial<NonTradingDay4Fund> => ({
  recId: 0,
  dDate: null as unknown as string,
  fundId: 0,
  comment: '',
  userId: null,
});

export function NonTradingDays4FundPage() {
  return (
    <LopCrudPage<NonTradingDay4Fund>
      resourceCode="nonTradingDays4Fund"
      titleKey="nonTradingDays4Fund.pageTitle"
      idField="recId"
      getRows={getNonTradingDays4Fund}
      saveBatch={(added, modified, deletedIds) =>
        saveNonTradingDays4FundBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newDefaults}
    />
  );
}
